import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { uid } from 'uid';
import { PATH } from '../../../constants';

import { ReactComponent as Icon } from '../../../img/readmore-arrow.svg';

const Breadcrumb = ({ categoryName, entryName }) => {
    const { t } = useTranslation();
    const { category, entry } = useParams();

    const ListItem = ({ children }) => (
        <li className="breadcrumb__item" data-nr="breadcrumb-item">
            {children}
        </li>
    );

    const getPath = (segment) => `${PATH.helpAndSupport}/${segment}`;
    const getLink = (href, text, current) => (
        <ListItem key={href}>
            <Link
                className="breadcrumb__link"
                to={href}
                {...(current && { 'aria-current': 'page' })}
            >
                {text}
            </Link>
            {!current && getSeparator()}
        </ListItem>
    );
    const getSeparator = () => <Icon key={uid()} className="breadcrumb__icon icon icon--xxs" aria-hidden="true" />;

    const getHomeAnchor = (href, text) => (
        <ListItem key={href}>
            <a
                className="breadcrumb__link"
                href={href}
            >
                {text}
            </a>
            {getSeparator()}
        </ListItem>
    );

    const createBreadcrumb = (path, text, separator) =>
        path && text ? getLink(path, text, separator) : [];

    const createBreadcrumbs = ({ category, entry }) => [
        getHomeAnchor(PATH.home, `${t('ui.breadcrumb.home')}`),
        getLink(PATH.helpAndSupport, `${t('ui.breadcrumb.helpAndSupport')}`, false),
        createBreadcrumb(getPath(category), categoryName, !entry),
        createBreadcrumb(getPath(`${category}/${entry}`), entryName, true)
    ];

    const breadcrumbs = createBreadcrumbs({ category, entry });

    return (
        <nav aria-label="Breadcrumb" className="breadcrumb" data-cy="breadcrumb">
            <ol className="breadcrumb__list">
                {breadcrumbs}
            </ol>
        </nav>
    );
};

export default Breadcrumb;
